export const environment = {
  production: true,
  development: false,
  test: false,
  authorizeProspectBrands: '[\"VYV\", \"HM\", \"MGEN\", \"MNT\"]',
  product: 'HC',
  brand: 'VYV',
  apiV2RootUrl: 'https://dev-02.assurance.vyv-conseil.fr/api/',
  baseUrl: 'https://dev-02.assurance-habitation.vyv-conseil.fr/',
  matomotoKey: 'CHANGEME',
  appInsightsKey: '886dda55-c8da-4007-bae9-81b529bb372b',
  assGarantie:
    'https://saboiardbackofficely7rr.blob.core.windows.net/public/Plaquette_Assurance_Protection_Juridique_Tableau%20des%20garanties.pdf',
  matomoSiteId: 6,
  matomoHostUrl: 'https://matomo-recette.vyv-extension-essai.aws.mgen.fr/',
  matomoScriptUrl: 'https://matomo-recette.vyv-extension-essai.aws.mgen.fr/js/container_682wvypB.js',
  urlWarranty: {
    assConfort:
      'https://saboiardbackofficely7rr.blob.core.windows.net/public/VYV_Plaquette_Assurance_Habitation_Confort_Tableau%20des%20garanties.pdf',
    assMetropole:
      'https://saboiardbackofficely7rr.blob.core.windows.net/public/VYV_Plaquette_Assurance_Habitation_{0}_Tableau%20des%20garanties.pdf',
    assSolidaire:
      'https://saboiardbackofficely7rr.blob.core.windows.net/public/VYV_Plaquette_Assurance_Habitation_Solidaire_Tableau%20des%20garanties.pdf',
  },
  modeleCourrierResiliation: 'https://saboiardbackofficely7rr.blob.core.windows.net/public/ModeleCourrier.docx',
  msalConfig: {
    auth: {
      clientId: '5efe220a-c830-480c-9ef1-9e66a9e26d19',
      authority: 'https://login.microsoftonline.com/6f12f368-4cb1-4b07-9574-dd2cdf95d9c1',
      redirectUri: 'https://dev-02.assurance-habitation.vyv-conseil.fr/',
    },
  },
  apiConfig: {
    scopes: ['api://boiard-dev-02-back-office/Read.All', 'api://boiard-dev-02-back-office/Write.All'],
    uri: 'https://dev-02.assurance.vyv-conseil.fr/api/',
  },
  url_espace_adherent: 'https://dev-02.assurance.vyv-conseil.fr/mon-espace/',
  googleTagManagerId: 'GTM-M2XCS4XC',
  skeepersTagId: '0ca9a77d9faddd0653a92063233c1633-3959'
};
